import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-popover-content} KatalPopoverContent A container for all the content of the popover. This is the element that will be positioned over the
 * page.
 */
class KatalPopoverContent extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatalPopoverContent.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();

    this.render();
  }

  render() {
    // Used by Popper.js to display the arrow
    let arrow = this.getElementsByClassName('kat-popover-arrow')[0];
    if (!arrow) {
      arrow = document.createElement('span');
      arrow.classList.add('kat-popover-arrow');
      this.appendChild(arrow);
    }
  }
}

KatalComponent.register('kat-popover-content', KatalPopoverContent);
